'use es6';

import { Record } from 'immutable';
import { Networks } from '../../lib/Constants';
import { BiddingStrategyType } from 'AdsUI/lib/Constants'; // https://git.hubteam.com/HubSpot/Ads/blob/master/AdsBase/src/main/java/com/hubspot/ads/data/reports/AdGroupDataIF.java

export default Record({
  accountId: null,
  biddingStrategyType: BiddingStrategyType.MANUAL_CPC,
  campaignId: null,
  conversionRate: null,
  id: null,
  maxCpc: null,
  name: null,
  network: Networks.ADWORDS,
  previousState: null,
  status: null,
  targetCpa: null,
  targetRoas: null
});